import React from 'react';
import { VerifiedUser as VerifiedIcon, Payment as PaymentIcon, Lock as LockIcon } from '@material-ui/icons';
import styled from 'styled-components';

const BadgeRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
  flex-wrap: wrap;
  margin: 1rem 0 0;
`;

const Badge = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  border: 1px solid #6464ff;
  border-radius: 999px;
  background: linear-gradient(135deg, #2a2a2a, #1f1f1f);
  color: #d4af37;
  font-size: 12px;
  font-weight: 600;
  box-shadow: 0 0 15px rgba(100, 100, 255, 0.4), inset 0 1px 2px rgba(212, 175, 55, 0.2);
  transition: all 0.3s ease;

  &:hover {
    box-shadow: 0 0 25px rgba(100, 100, 255, 0.6), 0 0 40px rgba(212, 175, 55, 0.3);
    transform: translateY(-2px);
    border-color: #8484ff;
  }
`;

const IconWrap = styled.span`
  display: inline-flex;
  align-items: center;
  color: #8b5cf6;
  filter: drop-shadow(0 0 4px rgba(139, 92, 246, 0.6));
`;

const ComplianceBadges = () => (
  <BadgeRow>
    <Badge title='PCI DSS Compliant Payment Processing'>
      <IconWrap>
        <PaymentIcon fontSize='small' />
      </IconWrap>
      PCI Compliant
    </Badge>
    <Badge title='256-bit TLS encryption'>
      <IconWrap>
        <LockIcon fontSize='small' />
      </IconWrap>
      Secure Checkout
    </Badge>
    <Badge title='Payments handled by Stripe'>
      <IconWrap>
        <VerifiedIcon fontSize='small' />
      </IconWrap>
      Stripe Verified
    </Badge>
  </BadgeRow>
);

export default ComplianceBadges;
